import { compact, map, split, trim } from 'lodash'

const UNLISTED_VENUES = process.env.NEXT_PUBLIC_UNLISTED_VENUES || ''

const UNLISTED_VENUES_ARRAY = compact(map(split(UNLISTED_VENUES, /[;,]/), (item) => trim(item)))

const filterUnlistedVenues = <T extends { id: string }>(venues: T[]): T[] =>
  venues.filter((venue) => !UNLISTED_VENUES_ARRAY.includes(venue.id))

export default filterUnlistedVenues
